import React from 'react';
import QuantPortal from './portal';
import Article from './article'

const renderArticle = (article, idx) => <Article key={idx} article={article} />

const PlanDetailsDescription = ({ title, articles }) => <div className="plan-details">
  <h6 className="plan-details-title">{title}</h6>
  <div className="hr -secondary" />
  {articles.map(renderArticle)}
</div>

const renderPlanDetailsDesciption = ({ title, articles }, idx) => 
  <PlanDetailsDescription key={idx} title={title} articles={articles} />

const PlanDetailsModal = ({ open, handleClose, plan }) => {
  if (!open) return null;
  
  const { name, description } = plan;

  return <QuantPortal title={name} open={open} handleClose={handleClose}>
    {description.map(renderPlanDetailsDesciption)}
  </QuantPortal>
};

export default PlanDetailsModal;